export const account = {
    title: "My Account",
    name: "Name",
    email: "Email",
    schoolId: "School ID",
    course: "Course",
    major: "Major",
    interestedDepartments: "Interested Departments",
    logout: "Logout",
    sparcsssoCaption: "This information can be changed in <bold>SPARCS SSO</bold>",
    kaistPortalCaption:
        "This information is synced with KAIST Portal. If the information does not match, please contact <bold>otlplus@sparcs.org</bold>",
}
